'use strict';

module.exports = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var params = ['%c[' + args.shift() + ']', 'color:blue;font-weight:bold;'];
  params = params.concat(args);
  console.log.apply(console, params);
};



//////////////////
// WEBPACK FOOTER
// ./~/lmw-console-log/index.js
// module id = lotU
// module chunks = 0